import React from 'react';
const links = ['English Ready™ Terms & Conditions', 'Privacy Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-99" data-mp="3ggtymjf7hl5r">
      <div className="mx-auto max-w-5xl text-center" data-id="element-100" data-mp="32o4deh7i4k9p">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-101" data-mp="32pp6s3i2xx5z">
          English Ready
        </p>
        <nav aria-label="Footer" data-id="element-102" data-mp="36n3bbhutfgrn">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-103" data-mp="3uesa9h2573hk">
            {links.map(link => <li key={link} data-id="element-104" data-mp="36d2kv7umpm9">
                <a href="#offer" className="transition-colors hover:text-brand" data-id="element-105" data-mp="3levkfc40nykx">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-106" data-mp="29zgj5w4rykk0">
          © 2026 English Ready — All rights reserved.
        </p>
      </div>
    </footer>;
}